(function() {
var PINNED_VARIANTS = [
  '51640251777298',  // Moisture Shine - Cherry On Top (seq 2)
  '52269389971730',  // Peptide Lip Conditioner - Berry Bliss (seq 3)
  '51853581582610',  // Love Bites - Golden Charm (seq 4)
  '51147143479570',  // Pout Perfect 4.2g - Take A Chance (seq 5)
  '51640251678994',  // Moisture Shine - Velvet Toast (seq 6)
  '51853581615378',  // Love Bites - Silver Spell (seq 7)
  '51135673925906',  // Gloss Glee - Barely Blushing (seq 8)
  '51135948980498'   // Bold Bliss - Brownie Sundae (seq 9)
];

  function getVariantFromItem(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.href.match(/variant=(\d+)/);
    if (!match) {
      var hMatch = link.href.match(/\/products\/([^?#/]+)/);
      return hMatch ? 'nv_' + hMatch[1] : null;
    }
    return match[1];
  }

  function reorderProducts() {
    var container = document.querySelector('[data-product-container]');
    if (!container) return;

    var items = Array.from(container.querySelectorAll('.m-product-item'));
    if (items.length === 0) {
      setTimeout(reorderProducts, 400);
      return;
    }

    var isBulletLipstick = window.location.pathname.indexOf('/collections/bullet-lipstick') !== -1;

    if (isBulletLipstick) {
      var variantMap = {};
      items.forEach(function(item) {
        var vid = getVariantFromItem(item);
        if (vid) variantMap[vid] = item;
      });

      var pinned = [];
      var usedItems = new Set();

      PINNED_VARIANTS.forEach(function(vid) {
        if (variantMap[vid] && !usedItems.has(variantMap[vid])) {
          pinned.push(variantMap[vid]);
          usedItems.add(variantMap[vid]);
        }
      });

      var remaining = items.filter(function(item) {
        return !usedItems.has(item);
      });
      remaining.sort(function() { return Math.random() - 0.5; });

      pinned.concat(remaining).forEach(function(item) {
        container.appendChild(item);
      });

      console.log('Pinned:', pinned.length, '| Shuffled:', remaining.length);

    } else {
      items.sort(function() { return Math.random() - 0.5; });
      items.forEach(function(item) { container.appendChild(item); });
      console.log('Shuffled:', items.length, 'on', window.location.pathname);
    }
  }

  window.addEventListener('load', function() {
    setTimeout(reorderProducts, 500);
  });

})();